module.exports = __webpack_public_path__ + "img/Airbnb-Working-From-Office-Keyboard-and-mouse-1-scaled.d812ae48.jpg";